import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCategoryBySeo = (seo, category) => {
  return {
    type: actionTypes.SET_CATEGORY_BY_SEO,
    payload: { seo, category }
  }
}
